module.exports = __webpack_public_path__ + "img/o-d-download.04a2f956.svg";